import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from 'react-router-dom';
import {
  isTokenExpired,
  removeToken,
  getToken,
  decodeToken,
} from './utils/TokenUtils';

import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';

import Footer from './components/Footer';
import Charts from './components/Charts';

import { updateFavicon } from './utlis';
import { API_URL } from './constants/api';

import socket from './utils/socket';

import AppRoutes from './routes/AppRoutes';
import Topbar from './components/TopBar';
import { HorizontalFormContextProvider } from './context/HorizontalFormContext';

const App = () => {
  console.log('bs:', window.bootstrap);

  return (
    <Router>
      <AppContent />
    </Router>
  );
};
const AppContent = () => {
  const location = useLocation(); // Get current route location
  const navigate = useNavigate();

  useEffect(() => {
    // Get the token from localStorage
    const token = getToken();
    const loginPage = decodeToken(token, 'loginPage');
    const isEnabled2FA = decodeToken(token, 'isEnabled2FA');
    const isVerified2FA = decodeToken(token, 'is2FaVerified');
    const is2FAForce = decodeToken(token, 'is2FAForce');

    const logoUrl = decodeToken(token, 'logo');

    const currentPage = location.pathname;
    if (token) {
      // Listen for real-time notifications
      socket.on('receive-notification', (data) => {
        console.log('🔔 New Notification:', data);
        alert('🔔 New Notification:');
        // You can show a toast or update state/UI here
      });

      // Cleanup on unmount
      return () => {
        socket.off('receive-notification');
      };
    }
    // console.log('currentPage:', currentPage);
    if (
      !token &&
      !currentPage.includes('/login/') &&
      !currentPage.includes('/portal/') &&
      !currentPage.includes('/forgot-') &&
      !currentPage.includes('/reset-') &&
      !currentPage.includes('/verify-') &&
      !currentPage.includes('-2fa') &&
      !currentPage.includes('/login-documentation') &&
      !currentPage.includes('/web') &&
      !currentPage.includes('/registration-letter') &&
      !currentPage === '/' &&
      !currentPage.includes('/registration/international-ngo-form') &&
      !currentPage.includes('/portal-promo') &&
      !currentPage.includes('/elearn.euniso.so') &&
      !currentPage.includes('/portal-promo') &&
      !currentPage.includes('/elearning')
    ) {
      // console.log('no token:', token);
      navigate(`/login/user-login`); // Redirect to login page
      // navigate('/')
    }
    // Check if token exists and if it's expired
    if (token && isTokenExpired(token)) {
      // If token expired, remove it from localStorage and redirect to login page
      removeToken();
      //   console.log('expired:');

      navigate(`/login/${loginPage}`); // Redirect to login page
    }
    // Check if is Enabled 2FA and is not Verified 2FA
    if (isEnabled2FA && !isVerified2FA) {
      navigate(`/check-2fa`); // Redirect to check 2fa page
    }

    // if (is2FAForce && !isEnabled2FA) {
    //   // console.log('is2FAForce:',  is2FAForce);

    //   // Redirect to the dashboard
    //   navigate('/register-2fa');
    // }

    if (logoUrl) {
      const iconUrl = `${API_URL}/${logoUrl}`;
      updateFavicon(iconUrl);
    }
  }, [navigate]);

  // List of routes where we don't want to show the Navbar
  const hideNavbarRoutes = [
    '/',
    '/login/:loginRoute',
    '/forgot-password/:forgotRoute',
    '/print',
    '/print-activity',
    '/print-activity2',

    '/reset-password/:token',
    '/verify-email/:token',
    '/register-2fa',
    '/check-2fa',
    '/pos-invoice/:route/:id',
    '/sales-invoice/:route/:id',
    '/student-invoice/:route/:id',
    '/student-invoice/:route/:fee_id/:id',
    '/pos-invoice/:route',
    '/passcard/:route/:id/:exam_id',
    '/passcard2/:route/:id/:exam_id',
    '/class-passcard/:route/:class_id',
    '/class-passcard2/:route/:class_id',
    '/registration-letter/:route/:id',
    '/portal/:route',
    '/invoice/:route/:id',
    '/tracking/:route',

    '/qrcode/:route/:id',

    '/documentation/:_id/:type',
    '/sys-features/:_id/:type',

    '/report/balance-sheet',
    '/report/income-statement',
    '/login-documentation/:email',
    '/registration/international-ngo-form',
    '/web',
    '/privacy-policy',

    '/portal-promo',
    '/api-documentation/:link_id',
    '/election/candidates',
    '/election/results',
    '/election/live-results',
    '/detailCategoryLetter/:route/:id',
    '/summaryCategoryLetter/:route/:id',
    '/MaternityDeliveryNote/:id',
    '/elearningHome',
    '/about',
    '/contact',
    '/programs',
    '/admssionRequirement',
    '/department/:departmentId',

    '/portalApp',
    '/coursedetails/:courseId',
    '/student-portal',
    '/questions',
    '/quiz',

    '/invoice-book',
    '/qr-code',
    '/generate-certificate',
    '/upload-certificate',
    '/ktcEHome',
    '/ktcAbout',
    '/ktcadmssionRequirement',
    '/ktcContact',
    '/ktcProgram',
    '/ktcPortal',
    '/ExamCamere',
    '/ExamStudent/:StudentId',
    '/ExamAdmin',
    '/ktcquestions',
    '/Certificate/:certificate_id',
    '/complaint-letter/:route/:id'
  ];
  // Helper function to match routes with parameters
  const matchRoute = (path, pattern) => {
    const regex = new RegExp(`^${pattern.replace(/:[^\s/]+/g, '([^/]+)')}$`); // Replace :param with a regex group
    const match = path.match(regex);

    if (match) {
      // Create an object mapping parameter names to values
      const paramNames = (pattern.match(/:[^\s/]+/g) || []).map((param) =>
        param.slice(1)
      );
      const params = {};
      paramNames.forEach((param, index) => {
        params[param] = match[index + 1];
      });
      return params; // Return the matched parameters
    }

    return null;
  };

  // // Check if the current route should hide the Navbar
  // const shouldHideNavbar = hideNavbarRoutes.some((route) => matchRoute(location.pathname, route));

  // Check if the current route should hide the Navbar
  const shouldHideNavbar = hideNavbarRoutes.some((route) => {
    const params = matchRoute(location.pathname, route);
    if (params) {
      // console.log(`Route matched: ${route}`);
      // console.log('Matched parameters:', params);
      return true; // Matched route with parameters
    }
    return false; // No match found
  });

  // List of routes where we will want to show the Charts
  const showChartsRoutes = ['/dashboard', '/charts'];
  // Check if the current route should show the Chart
  const shouldShowCharts = showChartsRoutes.includes(location.pathname);

  return (
    <>
      {/* Conditionally render the Navbar */}
      {(!process.env.REACT_APP_LAYOUT ||
        process.env.REACT_APP_LAYOUT === 'V1') && (
        <>
          {/* Your V1 layout components here */}
          {!shouldHideNavbar && <Navbar />}
          {shouldShowCharts && <Charts />}
          <AppRoutes />
          {!shouldHideNavbar && <Footer />}
        </>
      )}

      {process.env.REACT_APP_LAYOUT === 'V2' &&
        (shouldHideNavbar ? (
          // If we should hide navbar, just render the routes normally
          <AppRoutes />
        ) : (
          // V2 layout: Sidebar + Topbar + AppRoutes
          <div className="d-flex">
            {/* Sidebar fixed on the left */}
            <Sidebar />

            {/* Main content */}
            <div
              className="flex-grow-1 d-flex flex-column"
              style={{ marginLeft: 0 }} // remove any margin-left
            >
              <Topbar />
              <div
                className="flex-grow-1 overflow-auto "
                style={{ marginTop: '130px', marginLeft: '280px' }}
              >
                {shouldShowCharts && <Charts />}
                <AppRoutes />
                <Footer />
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default App;
